module.exports = __webpack_public_path__ + "img/738.15500dfa.png";